import { normalizeSummaryCell } from '../features/summary/renderSummary';

export class SummaryCellBuilder {
    constructor() {
        this._cell = {
            id: '',
            value: '',
            format: null,
            className: '',
            placeholder: ''
        };
    }

    withId(id) {
        this._cell.id = id;
        return this;
    }

    withValue(value) {
        this._cell.value = value;
        return this;
    }

    withFormat(formatFn) {
        this._cell.format = formatFn;
        return this;
    }

    withClass(className) {
        this._cell.className = className;
        return this;
    }

    withPlaceholder(placeholder) {
        this._cell.placeholder = placeholder;
        return this;
    }

    build() {
        return normalizeSummaryCell(this._cell);
    }
}
